import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

import { ref, onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const showNotice = ref(false);

onMounted(() => {
    if (sessionStorage.getItem("reauth_notice") === "1") {
        showNotice.value = true;
        sessionStorage.removeItem("reauth_notice");

        setTimeout(() => {
            showNotice.value = false;
        }, 4000);
    }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showNotice.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Your session expired. Reconnecting... "))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}
}

})